
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $abc74bbe028e649d$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"izUj7\",\"index.4486bc4d.js\",\"1dPKL\",\"robogebra-footer-logo.f097702f.svg\",\"g3GYT\",\"scroll-to-top.defda773.svg\",\"hExi8\",\"box-sum.04ec19e5.png\",\"egcF3\",\"solutionimage11.01cbdfe5.png\",\"dEtie\",\"solutionimage12.bf3a34c2.png\",\"7x1Cz\",\"solutionimage5.e15e4d12.png\",\"2QlMC\",\"robogebra-og.3d90ac7e.jpg\"]"));

var $b3773c591ac0eb42$exports = {};
$b3773c591ac0eb42$exports = new URL("robogebra-footer-logo.f097702f.svg", import.meta.url).toString();


var $4cfeafcf552783b9$exports = {};
$4cfeafcf552783b9$exports = new URL("scroll-to-top.defda773.svg", import.meta.url).toString();


var $0bec0cd52915dd75$exports = {};
$0bec0cd52915dd75$exports = new URL("box-sum.04ec19e5.png", import.meta.url).toString();


var $d189c8723ceb0f64$exports = {};
$d189c8723ceb0f64$exports = new URL("solutionimage11.01cbdfe5.png", import.meta.url).toString();


var $5011e9457962bc87$exports = {};
$5011e9457962bc87$exports = new URL("solutionimage12.bf3a34c2.png", import.meta.url).toString();


var $06d8fe3f742e085b$exports = {};
$06d8fe3f742e085b$exports = new URL("solutionimage5.e15e4d12.png", import.meta.url).toString();


var $fd6ba011325b2346$exports = {};
$fd6ba011325b2346$exports = new URL("robogebra-og.3d90ac7e.jpg", import.meta.url).toString();


//navbar-overlay-menu
document.addEventListener("DOMContentLoaded", function() {
    const robogebraOGBanner1 = (0, (/*@__PURE__*/$parcel$interopDefault($fd6ba011325b2346$exports))); // TODO... Don't Remove
    const menuIcon = document.getElementById('menuIcon');
    if (menuIcon) menuIcon.addEventListener('click', toggleMenu);
    const overlayMenuIcon = document.getElementById('overlayMenu');
    if (overlayMenuIcon) overlayMenuIcon.addEventListener('click', onOverlayMenuClick);
    function toggleMenu() {
        overlayMenuIcon.classList.toggle('open');
        if (overlayMenuIcon.classList.contains('open')) {
            menuIcon.classList.remove('fa-bars');
            menuIcon.classList.add('fa-times');
        } else {
            menuIcon.classList.remove('fa-times');
            menuIcon.classList.add('fa-bars');
        }
    }
    function onOverlayMenuClick() {
        overlayMenuIcon.classList.toggle('open');
        menuIcon.classList.remove('fa-times');
        menuIcon.classList.add('fa-bars');
    }
});
// "Book a Demo" → centre the whole section in the viewport.
// A plain #book-a-demo jump puts the section's top edge at the top of the
// screen, so only the heading is visible and the points and contact boxes sit
// below the fold. This centres it when it fits, and falls back to a top-aligned
// jump when the section is taller than the viewport.
document.addEventListener("DOMContentLoaded", function() {
    const DEMO_ID = 'book-a-demo';
    function desiredScrollTop() {
        const target = document.getElementById(DEMO_ID);
        if (!target) return null;
        const rect = target.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        const viewport = window.innerHeight;
        const offset = rect.height <= viewport ? top - (viewport - rect.height) / 2 // fits: centre it
         : top - 24; // taller: align near the top
        return Math.max(0, offset);
    }
    // The section's position moves while the scroll is running: images and
    // iframes between here and there load on approach and push it down. A
    // fire-and-forget scroll therefore aims at a stale target and lands short
    // — on the previous section — and any after-the-fact correction shows up
    // as a second, separate jump.
    //
    // So drive the animation frame by frame and re-read the target on every
    // frame. Layout shifts are absorbed continuously and the motion stays one
    // smooth glide.
    //
    // Every step must use behavior:'instant', NOT 'auto'. Per CSSOM-View,
    // 'auto' means "use the element's CSS scroll-behavior" — and Bootstrap
    // sets scroll-behavior:smooth on :root. With 'auto' each frame kicks off
    // a fresh smooth animation that cancels the previous one, so the page
    // crawls a little way and stalls instead of reaching the section.
    function animateToDemo() {
        let cancelled = false;
        function onUserInput() {
            cancelled = true;
        }
        [
            'wheel',
            'touchstart',
            'keydown'
        ].forEach(function(evt) {
            window.addEventListener(evt, onUserInput, {
                passive: true
            });
        });
        function done() {
            [
                'wheel',
                'touchstart',
                'keydown'
            ].forEach(function(evt) {
                window.removeEventListener(evt, onUserInput);
            });
        }
        const start = window.scrollY;
        const startedAt = performance.now();
        // Scale the duration to the distance. This section sits ~4500px down,
        // and covering that in a flat 700ms reads as a jump rather than a
        // scroll. Roughly 0.35ms per pixel, clamped so short hops stay snappy
        // and long ones stay watchable.
        const distance = Math.abs((desiredScrollTop() || 0) - start);
        const duration = Math.min(1600, Math.max(450, distance * 0.35));
        // Tracks the target for a moment after the glide ends, in case
        // something below is still resolving. Eased, so it never snaps.
        function track(settleUntil) {
            if (cancelled || performance.now() > settleUntil) return done();
            const want = desiredScrollTop();
            if (want === null) return done();
            const gap = want - window.scrollY;
            if (Math.abs(gap) > 1) window.scrollTo({
                top: window.scrollY + gap * 0.25,
                behavior: 'instant'
            });
            requestAnimationFrame(function() {
                track(settleUntil);
            });
        }
        function frame(now) {
            if (cancelled) return done();
            const want = desiredScrollTop();
            if (want === null) return done();
            const p = Math.min(1, (now - startedAt) / duration);
            // easeInOutCubic — softer start and finish than quad over a long
            // distance, so it doesn't feel like it launches.
            const eased = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
            window.scrollTo({
                top: start + (want - start) * eased,
                behavior: 'instant'
            });
            if (p < 1) requestAnimationFrame(frame);
            else track(performance.now() + 600);
        }
        requestAnimationFrame(frame);
    }
    function scrollToDemo(smooth) {
        if (desiredScrollTop() === null) return;
        if (!smooth) {
            window.scrollTo({
                top: desiredScrollTop(),
                behavior: 'instant'
            });
            return;
        }
        animateToDemo();
    }
    document.querySelectorAll('a[href$="#' + DEMO_ID + '"]').forEach(function(link) {
        // Same-page links only; ./index.html#book-a-demo must still navigate.
        if (!link.getAttribute('href').startsWith('#')) return;
        link.addEventListener('click', function(event) {
            event.preventDefault();
            scrollToDemo(true);
            history.replaceState(null, '', '#' + DEMO_ID);
        });
    });
    // Arriving from another page, once images have settled and stopped shifting
    // the layout underneath us.
    if (window.location.hash === '#' + DEMO_ID) window.addEventListener('load', function() {
        setTimeout(function() {
            scrollToDemo(false);
        }, 100);
    });
});
//scroll-top-fuctionality
document.addEventListener("DOMContentLoaded", function() {
    const backToTopButton = document.getElementById("scrollTopBtn");
    if (backToTopButton) {
        window.addEventListener("scroll", ()=>{
            if (window.scrollY > window.innerHeight) backToTopButton.style.display = "block";
            else backToTopButton.style.display = "none";
        });
        backToTopButton.addEventListener("click", ()=>{
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        });
    }
});
document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll('.abt-see-more-btn');
    buttons.forEach((button)=>{
        button.addEventListener('click', function() {
            const container = this.closest('.team-container');
            // Toggle expansion
            container.classList.toggle('expanded');
            // Optional: Toggle button text
            if (container.classList.contains('expanded')) this.textContent = 'See less...';
            else this.textContent = 'See more...';
        });
    });
    // Collapse when clicking outside
    document.addEventListener('click', function(event) {
        const expandedContainers = document.querySelectorAll('.team-container.expanded');
        expandedContainers.forEach((container)=>{
            if (!container.contains(event.target)) {
                container.classList.remove('expanded');
                // Reset the button text to "See more"
                const btn = container.querySelector('.abt-see-more-btn');
                if (btn) btn.textContent = 'See more...';
            }
        });
    });
});
// About-us section logic
document.addEventListener("DOMContentLoaded", ()=>{
    const topBio = document.getElementById("top-bio");
    const cards = document.querySelectorAll(".team-card");
    if (!topBio || cards.length === 0) return;
    // Attach click listeners to all cards
    cards.forEach((card)=>{
        card.addEventListener("click", ()=>{
            // Remove 'active' class from all cards
            cards.forEach((c)=>c.classList.remove("active"));
            // Add 'active' class to clicked card
            card.classList.add("active");
            // Show the bio
            const bio = card.getAttribute("data-bio");
            topBio.innerText = bio;
            topBio.classList.add("visible");
        });
    });
    // Select the first card by default
    cards[0].click();
});
// Audio Player Functionality
document.addEventListener('DOMContentLoaded', function() {
    const audioPlayer = document.getElementById('audioPlayer');
    const playPauseBtn = document.getElementById('playPauseBtn');
    if (!audioPlayer || !playPauseBtn) return;
    const playIcon = playPauseBtn.querySelector('.play-icon');
    const pauseIcon = playPauseBtn.querySelector('.pause-icon');
    const progressFill = document.getElementById('progressFill');
    const progressThumb = document.getElementById('progressThumb');
    const progressBar = document.querySelector('.progress-bar');
    const currentTimeDisplay = document.getElementById('currentTime');
    let isDragging = false;
    // Format time helper function
    function formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    // Update progress bar
    function updateProgress() {
        if (isDragging) return;
        const duration = audioPlayer.duration || 0;
        const currentTime = audioPlayer.currentTime || 0;
        const progressPercent = duration ? currentTime / duration * 100 : 0;
        progressFill.style.width = progressPercent + '%';
        progressThumb.style.left = progressPercent + '%';
        currentTimeDisplay.textContent = formatTime(currentTime);
    }
    // Play/Pause functionality
    playPauseBtn.addEventListener('click', function() {
        if (audioPlayer.paused) audioPlayer.play().then(()=>{
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'block';
        }).catch((error)=>{
            console.error('Error playing audio:', error);
        });
        else {
            audioPlayer.pause();
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
        }
    });
    // Progress bar click/drag functionality
    function updateAudioTime(event) {
        const progressBarRect = progressBar.getBoundingClientRect();
        const clickX = event.clientX - progressBarRect.left;
        const progressBarWidth = progressBarRect.width;
        const clickPercent = clickX / progressBarWidth * 100;
        const newTime = clickPercent / 100 * audioPlayer.duration;
        if (isFinite(newTime)) {
            audioPlayer.currentTime = newTime;
            updateProgress();
        }
    }
    progressBar.addEventListener('click', updateAudioTime);
    // Drag functionality for progress thumb
    progressThumb.addEventListener('mousedown', function(e) {
        isDragging = true;
        e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) {
        if (isDragging) updateAudioTime(e);
    });
    document.addEventListener('mouseup', function() {
        isDragging = false;
    });
    // Audio event listeners
    audioPlayer.addEventListener('timeupdate', updateProgress);
    audioPlayer.addEventListener('loadedmetadata', function() {
        currentTimeDisplay.textContent = formatTime(0);
        updateProgress();
    });
    audioPlayer.addEventListener('ended', function() {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
        progressFill.style.width = '0%';
        progressThumb.style.left = '0%';
        currentTimeDisplay.textContent = formatTime(0);
    });
    // Initialize display
    currentTimeDisplay.textContent = '03:00'; // Default duration as shown in image
});
// Coming Soon Modal Functions - Global scope
window.showComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }
};
window.hideComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }
};
// Close modal when clicking outside of it
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) modal.addEventListener('click', function(event) {
        if (event.target === modal) hideComingSoonModal();
    });
    // Load shared footer
    $e73bf42412feb220$var$loadSharedFooter();
});
// Shared Footer Component
function $e73bf42412feb220$var$loadSharedFooter() {
    const footerHTML = `
        <footer class="footer-container">
            <div class="container-xl">
                <div class="row py-md-5 justify-content-center">
                    <!-- Logo Section -->
                    <div class="col-md-4 col-sm-12 d-flex flex-column align-items-center justify-content-center footer-logo-section">
                        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($b3773c591ac0eb42$exports)))}" alt="Robogebra Logo" class="footer-logo-img">
                    </div>

                    <!-- Company Section -->
                    <div class="col-md-4 col-6 d-flex flex-column align-items-center">
                        <h5 style="color: #6b6b6b; font-weight: 400; text-transform: uppercase; font-size: 14px;" class="mb-0">Company</h5>
                        <ul class="list-unstyled mt-3 mb-0 ms-3">
                            <li class="mb-2"><a href="./index.html#book-a-demo" style="color: #8B4B99; text-decoration: none;">Book a Demo</a></li>
                            <li class="mb-2"><a href="./about-us.html" style="color: #8B4B99; text-decoration: none;">About Us</a></li>
                            <li class="mb-2"><a href="./team.html" style="color: #8B4B99; text-decoration: none;">Team</a></li>
                            <li class="mb-2"><a href="./contact-us.html" style="color: #8B4B99; text-decoration: none;">Contact Us</a></li>
                            <li class="mb-2"><a href="https://app.robogebra.ai/login" target="_blank" style="color: #8B4B99; text-decoration: none;">Sign in</a></li>
                        </ul>
                    </div>

                    <!-- Connect with Us Section -->
                    <div class="col-md-4 col-6 d-flex flex-column align-items-center">
                        <h5 style="color: #6b6b6b; font-weight: 400; text-transform: uppercase; font-size: 14px; margin-left: 24px;" class="mb-0">Connect with Us</h5>
                        <ul class="list-unstyled mt-3  mb-0">
                            <li class="mb-2">
                                <a href="https://www.linkedin.com/company/robogebra-ai" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-linkedin" style="color: #8B4B99; margin-right: 8px;"></i>LinkedIn
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://www.youtube.com/@robogebra" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-youtube" style="color: #8B4B99; margin-right: 8px;"></i>YouTube
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://www.instagram.com/robogebra" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-instagram" style="color: #8B4B99; margin-right: 8px;"></i>Instagram
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://x.com/robogebra_ai" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-x-twitter" style="color: #8B4B99; margin-right: 8px;"></i>X
                                </a>
                            </li>
                            <li class="mb-2">
                                <a href="https://robogebra.discourse.group/" target="_blank" style="color: #8B4B99; text-decoration: none;">
                                    <i class="fab fa-discourse" style="color: #8B4B99; margin-right: 8px;"></i>Community
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Bottom Footer Bar -->
        <div class="bottom-footer-bar">
            <div class="container-xl">
                <div class="row py-3 align-items-center justify-content-center">
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;">
                            <strong style="color: #fff;">Contact Us</strong>
                            <a href="mailto:support@robogebra.ai" style="color: #9ca3af; text-decoration: none;">support@robogebra.ai</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;">
                            <strong style="color: #fff;">Legal</strong>
                            <a href="./terms.html" style="color: #9ca3af; text-decoration: none;">Terms of Service</a>
                            <span class="mx-2" style="color: #9ca3af;">|</span>
                            <a href="./policy.html" style="color: #9ca3af; text-decoration: none;">Privacy Policy</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <p class="mb-0" style="color: #9ca3af;"><strong style="color: #fff;">Copyright</strong> \xa9 2025 Robogebra LLP</p>
                    </div>
                </div>
            </div>
        </div>
        
        
        <button id="scrollTopBtn" class="scroll-top-btn" style="cursor: pointer!important;">
            <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($4cfeafcf552783b9$exports)))}" alt="scroll-icon" class="scroll-icon me-1">
            Go to Top
        </button>
    `;
    // Find existing footer and replace it, or add to end of body if no footer exists
    const existingFooter = document.querySelector('footer.footer-container');
    const existingScrollBtn = document.querySelector('#scrollTopBtn');
    const existingBottomFooter = document.querySelector('.bottom-footer-bar');
    if (existingFooter) {
        // Remove existing components
        existingFooter.remove();
        if (existingScrollBtn) existingScrollBtn.remove();
        if (existingBottomFooter) existingBottomFooter.remove();
    }
    // Add the new footer before the last script tag
    const scripts = document.querySelectorAll('script');
    const lastScript = scripts[scripts.length - 1];
    lastScript.insertAdjacentHTML('beforebegin', footerHTML);
    // Initialize scroll to top functionality
    $e73bf42412feb220$var$initializeScrollToTop();
}
// Initialize scroll to top functionality
function $e73bf42412feb220$var$initializeScrollToTop() {
    const scrollTopBtn = document.getElementById('scrollTopBtn');
    if (scrollTopBtn) {
        // Show/hide scroll button based on scroll position
        window.addEventListener('scroll', function() {
            if (window.pageYOffset > 300) scrollTopBtn.style.display = 'flex';
            else scrollTopBtn.style.display = 'none';
        });
        // Scroll to top when button is clicked
        scrollTopBtn.addEventListener('click', function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
}
const $e73bf42412feb220$var$solutionData = [
    {
        id: 1,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($0bec0cd52915dd75$exports))),
        url: "https://app.robogebra.ai/exercise/6745963c7ce9d810b13f1828/exercise-item/17/solution"
    },
    {
        id: 2,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5011e9457962bc87$exports))),
        url: "https://app.robogebra.ai/exercise/687b3c32cca0583e95ec69ca/exercise-item/1/solution"
    },
    {
        id: 3,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d189c8723ceb0f64$exports))),
        url: "https://app.robogebra.ai/exercise/673601373f90cacab21ea985/exercise-item/6/solution"
    },
    {
        id: 4,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($06d8fe3f742e085b$exports))),
        url: "https://app.robogebra.ai/exercise/673601393f90cacab21ea9c1/exercise-item/4/solution"
    }
];
const $e73bf42412feb220$var$solutionsGrid = document.getElementById('solutionsGrid');
const $e73bf42412feb220$var$modalOverlay = document.getElementById('modalOverlay');
const $e73bf42412feb220$var$modalImage = document.getElementById('modalImage');
const $e73bf42412feb220$var$modalClose = document.getElementById('modalClose');
function $e73bf42412feb220$var$createGridItems() {
    $e73bf42412feb220$var$solutionsGrid.innerHTML = '';
    $e73bf42412feb220$var$solutionData.forEach((solution)=>{
        const gridItem = document.createElement('div');
        gridItem.className = 'solution-item';
        gridItem.innerHTML = `
            <img class="solution-image" src="${solution.image}" loading="lazy">
            <div class="solution-overlay">
                <div class="zoom-icon">\u{1F50D}</div>
            </div>`;
        gridItem.addEventListener('click', ()=>{
            if (solution.url) window.open(solution.url, '_blank', 'noopener,noreferrer');
        });
        const img = gridItem.querySelector('.solution-image');
        img.addEventListener('error', ()=>{
            img.style.color = 'white';
            img.style.display = 'flex';
            img.style.alignItems = 'center';
            img.style.justifyContent = 'center';
            img.style.fontSize = '1.2rem';
            img.style.fontWeight = '600';
            img.alt = 'Sample Solution';
        });
        $e73bf42412feb220$var$solutionsGrid.appendChild(gridItem);
    });
}
function $e73bf42412feb220$var$openModal(solution) {
    $e73bf42412feb220$var$modalImage.src = solution.image;
    $e73bf42412feb220$var$modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}
function $e73bf42412feb220$var$closeModal() {
    $e73bf42412feb220$var$modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
}
$e73bf42412feb220$var$modalClose.addEventListener('click', $e73bf42412feb220$var$closeModal);
$e73bf42412feb220$var$modalOverlay.addEventListener('click', (e)=>{
    if (e.target === $e73bf42412feb220$var$modalOverlay) $e73bf42412feb220$var$closeModal();
});
document.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape' && $e73bf42412feb220$var$modalOverlay.classList.contains('active')) $e73bf42412feb220$var$closeModal();
});
document.addEventListener('DOMContentLoaded', ()=>{
    $e73bf42412feb220$var$createGridItems();
});
// Download Section Video Player
document.addEventListener('DOMContentLoaded', function() {
    const downloadImageContainer = document.getElementById('downloadImageContainer');
    const downloadVideoWrapper = document.getElementById('downloadVideoWrapper');
    const downloadVideoIframe = document.getElementById('downloadVideoIframe');
    if (downloadImageContainer && downloadVideoWrapper && downloadVideoIframe) downloadImageContainer.addEventListener('click', function() {
        // Hide the image container
        downloadImageContainer.style.display = 'none';
        // Show the video wrapper with purple frame
        downloadVideoWrapper.style.display = 'block';
        // Set the video URL with autoplay
        downloadVideoIframe.src = 'https://www.youtube.com/embed/NFuTAZ46bSE?autoplay=1';
    });
    // Testimonials Carousel
    const track = document.querySelector('.testimonials-track');
    const prevBtn = document.querySelector('.testimonial-prev');
    const nextBtn = document.querySelector('.testimonial-next');
    if (track && prevBtn && nextBtn) {
        // Align to real card positions instead of a fixed step, so the gap
        // difference across breakpoints can never make cards drift off-edge.
        const getCards = ()=>Array.from(track.querySelectorAll('.testimonial-card'));
        const getCurrentIndex = ()=>{
            const cards = getCards();
            const trackLeft = track.getBoundingClientRect().left;
            let index = 0;
            let closest = Infinity;
            cards.forEach((card, i)=>{
                const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
                if (distance < closest - 1) {
                    closest = distance;
                    index = i;
                }
            });
            return index;
        };
        const scrollToIndex = (index)=>{
            const cards = getCards();
            if (!cards.length) return;
            const target = cards[Math.max(0, Math.min(index, cards.length - 1))];
            const delta = target.getBoundingClientRect().left - track.getBoundingClientRect().left;
            track.scrollTo({
                left: track.scrollLeft + delta,
                behavior: 'smooth'
            });
        };
        const isAtEnd = ()=>track.scrollLeft >= track.scrollWidth - track.clientWidth - 5;
        prevBtn.addEventListener('click', ()=>scrollToIndex(getCurrentIndex() - 1));
        nextBtn.addEventListener('click', ()=>scrollToIndex(getCurrentIndex() + 1));
        const advance = ()=>{
            if (isAtEnd()) scrollToIndex(0);
            else scrollToIndex(getCurrentIndex() + 1);
        };
        // Auto-scroll every 4 seconds
        let autoScroll = setInterval(advance, 4000);
        const pause = ()=>clearInterval(autoScroll);
        const resume = ()=>{
            clearInterval(autoScroll);
            autoScroll = setInterval(advance, 4000);
        };
        // Pause auto-scroll while the user is interacting
        track.addEventListener('mouseenter', pause);
        track.addEventListener('mouseleave', resume);
        track.addEventListener('touchstart', pause, {
            passive: true
        });
        track.addEventListener('touchend', resume, {
            passive: true
        });
        // Re-align after a resize / orientation change
        let resizeTimer;
        window.addEventListener('resize', ()=>{
            clearTimeout(resizeTimer);
            const index = getCurrentIndex();
            resizeTimer = setTimeout(()=>scrollToIndex(index), 150);
        });
    }
});
/* Enlarged view for the inline clips — the "With Robogebra" comparison tile and
   the three feature clips. Any element with .video-zoom opens the shared
   lightbox, so adding another clip needs no JS change.

   The clip's URL and poster are read off its own inline <video> rather than
   from data attributes: Parcel rewrites src/poster to content-hashed paths at
   build time but leaves data-* alone, so a URL parked in a data attribute
   would 404 in the built site.

   The lightbox keeps its own <video> so the inline loops are left running, but
   it picks up the clicked clip's playback position, which makes the jump to the
   enlarged view seamless. */ document.addEventListener('DOMContentLoaded', function() {
    const triggers = document.querySelectorAll('.video-zoom');
    const lightbox = document.getElementById('videoLightbox');
    const closeBtn = document.getElementById('videoLightboxClose');
    const bigVideo = document.getElementById('videoLightboxVideo');
    const titleEl = document.getElementById('videoLightboxTitle');
    if (!triggers.length || !lightbox || !closeBtn || !bigVideo || !titleEl) return;
    let lastTrigger = null;
    function openLightbox(trigger) {
        const inlineVideo = trigger.querySelector('video');
        const sourceEl = inlineVideo && inlineVideo.querySelector('source');
        const src = sourceEl ? sourceEl.src : inlineVideo && inlineVideo.currentSrc;
        if (!src) return;
        lastTrigger = trigger;
        titleEl.textContent = trigger.getAttribute('data-video-title') || '';
        // Only reload when the clip actually changes — otherwise reopening the
        // same one would throw away what the browser already buffered.
        if (bigVideo.src !== src) {
            // Carry over the clip's dimensions so the element knows its aspect
            // ratio straight away. Without them a <video> reports the default
            // 300x150 until metadata arrives, and the card opens at that size
            // instead of filling the space the CSS allows.
            const width = inlineVideo.getAttribute('width');
            const height = inlineVideo.getAttribute('height');
            if (width && height) {
                bigVideo.setAttribute('width', width);
                bigVideo.setAttribute('height', height);
            }
            bigVideo.src = src;
            if (inlineVideo.poster) bigVideo.poster = inlineVideo.poster;
            bigVideo.load();
        }
        lightbox.classList.add('active');
        // Next frame, so the display change lands before the opacity transition.
        requestAnimationFrame(function() {
            lightbox.classList.add('is-visible');
        });
        document.body.style.overflow = 'hidden';
        if (inlineVideo && !isNaN(inlineVideo.currentTime)) {
            const resume = function() {
                bigVideo.currentTime = inlineVideo.currentTime;
                bigVideo.removeEventListener('loadedmetadata', resume);
            };
            if (bigVideo.readyState >= 1) resume();
            else bigVideo.addEventListener('loadedmetadata', resume);
        }
        const playing = bigVideo.play();
        if (playing && playing.catch) playing.catch(function() {});
        closeBtn.focus();
    }
    function closeLightbox() {
        lightbox.classList.remove('is-visible');
        bigVideo.pause();
        document.body.style.overflow = '';
        setTimeout(function() {
            lightbox.classList.remove('active');
        }, 250);
        if (lastTrigger) lastTrigger.focus();
    }
    triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
            openLightbox(trigger);
        });
        trigger.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                openLightbox(trigger);
            }
        });
    });
    closeBtn.addEventListener('click', closeLightbox);
    // Clicking the scrim outside the card also closes it.
    lightbox.addEventListener('click', function(event) {
        if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && lightbox.classList.contains('active')) closeLightbox();
    });
});


//# sourceMappingURL=index.4486bc4d.js.map
